import { InputSearchPro } from 'components/InputSearch';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { empresaToString } from 'utils/padronesToString';
import { padronesEnum } from '../enums';

const fieldsInfo = {};

const tabs = [
  {
    title: 'Información General',
    fields: [
      'empresa',
      'clave',
      'giros',
      'tipo_de_categoria_comercio_informal',
      'dias_laborales',
      'observaciones',
    ],
  },
];

const configs = {
  empresa: {
    advanced: true,
    control: InputSearchPro,
    rules: [{ required: true }],
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.EMPRESA, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Empresa',
    tooltip: 'Búsqueda por Razón social',
    resultProps: {
      name: 'empresa',
      label: 'Empresa',
      render: (empresa) => empresaToString(empresa),
    },
  },
  clave: {
    formItemProps: {
      label: 'Clave',
      required: true,
    },
  },
  giros: {
    formItemProps: {
      label: 'Giro De Comercio Informal',
      required: true,
    },
  },
  tipo_de_categoria_comercio_informal: {
    formItemProps: {
      label: 'Tipo De Categoría',
    },
  },
  dias_laborales: {
    formItemProps: {
      label: 'Días Laborales',
    },
  },
  observaciones: {
    formItemProps: {
      label: 'Observaciones',
      required: true,
    },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
